import EditInsurance from './EditInsurance';

export default EditInsurance;
